import './style.less';

/**
 * Барааны өөрчлөлтийн хүсэлтийн төлөв.
 * Жагсаалт болон дэлгэрэнгүй хоёр дээр нэг ижил харагдахын тулд нэг компонентоос
 * дуудна — өнгө нь `style.less` дэх класснаас.
 */

/** API-гийн `statusEnum` байхгүй үед хэрэглэх нөөц шошго */
export const STATUS_LABELS = {
  pending: 'Хүсэлт үүсгэсэн',
  approved: 'Зөвшөөрсөн',
  rejected: 'Татгалзсан',
  archived: 'Архивлагдсан',
  deleted: 'Устгасан',
};

const StatusBadge = ({ status, labels }) => {
  if (!status) return '-';

  return (
    <span className={`product-change-status-badge product-change-status-${status}`}>
      <span className="product-change-status-dot" />
      {labels?.[status] ?? STATUS_LABELS[status] ?? status}
    </span>
  );
};

export default StatusBadge;
